import baseAPI from '../axiosApi'

const api={
    list:'/api-ir/international/reception/page',
    add:'/api-ir/international/reception/add',
    update:'/api-ir/international/reception/edit',
    info:'/api-ir/international/reception/info/',
    del:'/api-ir/international/reception/delete/',
}
// 查询外事接待列表
export function list (data) {
    return baseAPI.axiosData(api.list,'get',data)
}
// 新增外事接待
export function add (data) {
    return baseAPI.axiosData(api.add,'post',data)
}
// 修改外事接待
export function update (data) {
    return baseAPI.axiosData(api.update,'put',data)
}
// 查询外事接待信息
export function info (id) {
    return baseAPI.axiosData(api.info+id,'get')
}
// 删除外事接待
export function del (id) {
    return baseAPI.axiosData(api.del+id,'delete')
}
